module.exports = __webpack_public_path__ + "img/stock7.68450af4.png";